"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _PeractoRoute = _interopRequireDefault(require("../PeractoRoute"));

var _Login = _interopRequireDefault(require("../Login"));

var _LoginForm = _interopRequireDefault(require("../Login/LoginForm"));

var _peractoAuth = require("@peracto/peracto-auth");

var _ForgottenForm = _interopRequireDefault(require("../Login/ForgottenForm"));

var _SetPasswordForm = _interopRequireDefault(require("../Login/SetPasswordForm"));

var _peractoUi = require("@peracto/peracto-ui");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var PeractoInner = function PeractoInner(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      loggingIn = _useState2[0],
      setIsLoggingIn = _useState2[1];

  var _useAuth = (0, _peractoAuth.useAuth)(),
      loading = _useAuth.loading,
      user = _useAuth.user,
      login = _useAuth.login;

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var onSubmit = function onSubmit(inputs) {
    setIsLoggingIn(true);
    setError(false);
    login(inputs)["catch"](function (e) {
      setError(e.message);
    })["finally"](function () {
      setIsLoggingIn(false);
    });
  };

  if (loading) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        height: '100vh'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "d-flex flex-grow-1 align-items-center flex-column justify-content-center h-100"
    }, /*#__PURE__*/_react["default"].createElement(_peractoUi.LoadingIcon, null)));
  }

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, {
    basename: "/"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/login",
    render: function render(props) {
      var _ref = props.location.state || {
        from: {
          pathname: '/'
        }
      },
          from = _ref.from;

      return user.authenticated ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        to: from
      }) : /*#__PURE__*/_react["default"].createElement(_Login["default"], props, /*#__PURE__*/_react["default"].createElement(_LoginForm["default"], {
        loggingIn: loggingIn,
        error: error,
        onSubmit: onSubmit
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/forgotten-password",
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_Login["default"], props, /*#__PURE__*/_react["default"].createElement(_ForgottenForm["default"], props));
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/set-password",
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_Login["default"], props, /*#__PURE__*/_react["default"].createElement(_SetPasswordForm["default"], props));
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/",
    render: function render(routeProps) {
      return /*#__PURE__*/_react["default"].createElement(_PeractoRoute["default"], _extends({}, props, routeProps));
    }
  }))));
};

var _default = PeractoInner;
exports["default"] = _default;